// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"3ebdfbbd","351":"8f175266","376":"3ebdfbbd","766":"3ebdfbbd","879":"a5bdaa6a","985":"3ebdfbbd"}[chunkId] + ".chunk.css";
};